import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { ResetPw2Schema } from "./validation";
import { useLocation, useHistory } from "react-router-dom";
import { resetPassword } from "../../api/auth";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Row, Form } from "react-bootstrap";
import Sallie from "../Sallie";
import SubmitButton from "../StyledComponents/SubmitButton";
import LabelledInput from "../LabelledInput";

const ResetPassword2 = () => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const { register, handleSubmit, errors, formState } = useForm({
    resolver: yupResolver(ResetPw2Schema),
  });
  const { touched } = formState;
  const url = new URLSearchParams(location.search);
  let token = url.get("token");

  // Store the message KEY so it re-translates if the language changes
  const [sallieKey, setSallieKey] = useState("signIn.resetPassword2.prompt");
  const [isLoading, setIsLoading] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);

  const onSubmit = (data) => {
    setIsLoading(true);
    data.token = token;
    resetPassword(data)
      .then(() => {
        setSallieKey("signIn.resetPassword2.success");
        setResetSuccess(true);
      })
      .catch((error) => {
        console.error(error); // Log the error for debugging purposes
        if (error.response) {
          if (error.response.status === 400) {
            // Invalid token
            setSallieKey("signIn.resetPassword2.invalidToken");
          } else if (error.response.status === 403) {
            // Expired token
            setSallieKey("signIn.resetPassword2.expiredToken");
          }
        } else {
          // Network or other unexpected errors
          setSallieKey("signIn.resetPassword2.unexpectedError");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Sallie text={t(sallieKey)} />
      {resetSuccess ? (
        <SubmitButton onClick={() => history.push("/signIn")}>
          {t("signIn.resetPassword2.goToLogin")}
        </SubmitButton>
      ) : (
        <Row className="d-flex justify-content-center">
          <Form
            autoComplete="on"
            method="POST"
            className="mt-2 d-flex flex-column align-items-center"
            style={{ margin: "0 auto" }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <LabelledInput
              labelAs="h6"
              name="password"
              type="password"
              label={t("signIn.signin.password")}
              inputRef={register}
              errors={errors}
              touched={touched}
            />
            <LabelledInput
              labelAs="h6"
              type="password"
              name="passwordConfirmation"
              label={t("signIn.resetPassword2.confirmPassword")}
              autoComplete="new-password"
              inputRef={register}
              errors={errors}
              touched={touched}
            />
            <SubmitButton disabled={isLoading} type="submit">
              {t("signIn.signin.resetPassword")}
            </SubmitButton>
          </Form>
        </Row>
      )}
    </>
  );
};

export default ResetPassword2;